import React, { Component } from "react";
import Chart from "chart.js";
import classes from "./Chart_Village_Gender_LineChart.module.css";
import { stockData } from "../../assets/data";

var countCranky = 0; var countCrankyF = 0; var countCrankyM = 0;
var countJock = 0; var countJockF = 0; var countJockM = 0;
var countLazy = 0; var countLazyF = 0; var countLazyM = 0;
var countNormal = 0; var countNormalF = 0; var countNormalM = 0;
var countPeppy = 0; var countPeppyF = 0; var countPeppyM = 0;
var countSisterly = 0; var countSisterlyF = 0; var countSisterlyM = 0;
var countSmug = 0; var countSmugF = 0; var countSmugM = 0;
var countSnooty = 0; var countSnootyF = 0; var countSnootyM = 0;
var typeFound = ['Cranky', 'Jock', 'Lazy', 'Normal', 'Peppy', 'Sisterly', 'Smug', 'Snooty' ];
// var myVillPers_array = { 'Cranky': [], 'Jock': [], 'Lazy': [], 'Normal': [], 'Peppy': [], 'Sisterly': [], 'Smug': [], 'Snooty': [] };
var myNumFVillPers_array = [];
var myNumMVillPers_array = [];

stockData.map((data, key) => { 
    if (data.gender == 'Female') {
        if (data.personality == 'Cranky') {
            countCranky = countCranky + 1;
            countCrankyF = countCrankyF + 1; 
        }  
        if (data.personality == 'Jock') {
            countJock = countJock + 1;
            countJockF = countJockF + 1;
        }
        if (data.personality == 'Lazy') {
            countLazy = countLazy + 1;
            countLazyF = countLazyF + 1;
        }
        if (data.personality == 'Normal') {
            countNormal = countNormal + 1;
            countNormalF = countNormalF + 1;
        }
        if (data.personality == 'Peppy') {
            countPeppy = countPeppy + 1;
            countPeppyF = countPeppyF + 1;
        }
        if (data.personality == 'Sisterly') {
            countSisterly = countSisterly + 1;
            countSisterlyF = countSisterlyF + 1;
        }
        if (data.personality == 'Smug') {
            countSmug = countSmug + 1;
            countSmugF = countSmugF + 1;
        }
        if (data.personality == 'Snooty') {
            countSnooty = countSnooty + 1;
            countSnootyF = countSnootyF + 1;
        }
    } else {
        if (data.personality == 'Cranky') {
            countCranky = countCranky + 1;
            countCrankyM = countCrankyM + 1; 
        }  
        if (data.personality == 'Jock') {
            countJock = countJock + 1;
            countJockM = countJockM + 1;
        }
        if (data.personality == 'Lazy') {
            countLazy = countLazy + 1;
            countLazyM = countLazyM + 1;
        }
        if (data.personality == 'Normal') {
            countNormal = countNormal + 1;
            countNormalM = countNormalM + 1;
        }
        if (data.personality == 'Peppy') {
            countPeppy = countPeppy + 1;
            countPeppyM = countPeppyM + 1;
        }
        if (data.personality == 'Sisterly') {
            countSisterly = countSisterly + 1;
            countSisterlyM = countSisterlyM + 1;
        }
        if (data.personality == 'Smug') {
            countSmug = countSmug + 1;
            countSmugM = countSmugM + 1;
        }
        if (data.personality == 'Snooty') {
            countSnooty = countSnooty + 1;
            countSnootyM = countSnootyM + 1;
        }
    }     
});
console.log('Cranky: ' + countCranky);
console.log('Jock: ' + countJock);
console.log('Lazy: ' + countLazy);
console.log('Normal: ' + countNormal);
console.log('Peppy: ' + countPeppy);
console.log('Sisterly: ' + countSisterly);
console.log('Smug: ' + countSmug);
console.log('Snooty: ' + countSnooty);

myNumFVillPers_array.push(countCrankyF);
myNumFVillPers_array.push(countJockF);
myNumFVillPers_array.push(countLazyF);
myNumFVillPers_array.push(countNormalF);
myNumFVillPers_array.push(countPeppyF);
myNumFVillPers_array.push(countSisterlyF);
myNumFVillPers_array.push(countSmugF);
myNumFVillPers_array.push(countSnootyF);

myNumMVillPers_array.push(countCrankyM);
myNumMVillPers_array.push(countJockM);
myNumMVillPers_array.push(countLazyM);
myNumMVillPers_array.push(countNormalM);
myNumMVillPers_array.push(countPeppyM);
myNumMVillPers_array.push(countSisterlyM);
myNumMVillPers_array.push(countSmugM);
myNumMVillPers_array.push(countSnootyM);

/* myVillPers_array.Cranky = countCranky;
myVillPers_array.Jock   = countJock;
myVillPers_array.Lazy   = countLazy;
myVillPers_array.Normal = countNormal;
myVillPers_array.Sisterly = countSisterly;
myVillPers_array.Smug = countSmug;
myVillPers_array.Snooty = countSnooty; */

export default class Chart_Village_Gender_LineChart extends Component {
    chartRef = React.createRef();

    componentDidMount() {
        const myChartRef = this.chartRef.current.getContext("2d"); 

        new Chart(myChartRef, {
            type: "line",
            data: {
                //Bring in data
                labels: typeFound, // typeFound // labels // ['A','B','C']
                datasets: [{
                    label: 'Female',  
                    data: myNumFVillPers_array, // numFound // data // [2,6,9]   		
                    backgroundColor: [
                        "rgba(255, 99, 132, 0.3)",
                        "rgba(54, 162, 235, 0.3)",			
                        "rgba(255, 206, 86, 0.3)",
                        "rgba(75, 192, 192, 0.3)",
                        "rgba(153, 102, 255, 0.3)", 
                        "rgba(138, 19, 55, 0.3)", 
                        "rgba(227, 3, 252, 0.3)",
                        "rgba(9, 87, 12, 0.3)"
                    ],
                    borderColor: [
                        "rgba(255, 99, 132, 1)",
                        "rgba(54, 162, 235, 1)",			
                        "rgba(255, 206, 86, 1)",
                        "rgba(75, 192, 192, 1)",
                        "rgba(153, 102, 255, 1)", 
                        "rgba(138, 19, 55, 1)", 
                        "rgba(227, 3, 252, 1)",
                        "rgba(9, 87, 12, 1)"
                    ],
                    borderWidth: 1,
                    fill: true,
                    lineTension: 0.3              
                  }, 
                  {
                    label: 'Male',  
                    data: myNumMVillPers_array, // numFound // data // [2,6,9]   		
                    backgroundColor: [
                        "rgba(54, 162, 235, 0.3)",
                        "rgba(255, 99, 132, 0.3)",			
                        "rgba(255, 206, 86, 0.3)",
                        "rgba(75, 192, 192, 0.3)",
                        "rgba(153, 102, 255, 0.3)", 
                        "rgba(138, 19, 55, 0.3)", 
                        "rgba(227, 3, 252, 0.3)",
                        "rgba(9, 87, 12, 0.3)"
                    ],
                    borderColor: [
                        "rgba(54, 162, 235, 1)",
                        "rgba(255, 99, 132, 1)",			
                        "rgba(255, 206, 86, 1)",
                        "rgba(75, 192, 192, 1)",
                        "rgba(153, 102, 255, 1)", 
                        "rgba(138, 19, 55, 1)", 
                        "rgba(227, 3, 252, 1)",
                        "rgba(9, 87, 12, 1)"
                    ],
                    borderWidth: 1,
                    fill: true,
                    lineTension: 0.3              
                  }                  
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                scales: {
                  xAxes: [{
                      ticks: { beginAtZero: true }
                  }]  
                    
                }
              }
        });
    
    
    }
    render() {
        return (
            <div className={classes.graphContainer}>
                <canvas
                    id="myChart"
                    ref={this.chartRef}
                />
            </div>

        )
    }   
}    